import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { flatten, deepen } from '../../versa/record.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/carriers.js';
import form from '../forms/carriers.js';
import * as types from '../types.js';

const carriers = function()
{

	let carriers_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_cities, this.queryAll()).then((data) => db.set('cities', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_carriers, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_carrier, ...JSON.parse(id));
			_record = flatten(_record, 'address');
			if (_record.address_city_id)
				_record['address_state'] = (await db.get('cities', _record.address_city_id)).state;
			return _record;
		},
		async saveRecord(data, old_data)
		{
			const isLocal = !!data.is_local_delivery;
			let _record = {
				type: isLocal ? 'L' : data.type,
				nick: data.nick,
				name: data.name,
				cpf: isLocal ? null : data.cpf,
				cnpj: isLocal ? null : data.cnpj,
				ie: isLocal ? null : data.ie,
				ie_type: isLocal ? null : data.ie_type,
				phone: data.phone,
				email: data.email,
				is_local_delivery: isLocal,
			};
			if (data.address_id || data.address_street)
				_record['address'] = {
					id: Number(data.address_id),
					street: data.address_street,
					number: data.address_number,
					complement: data.address_complement,
					district: data.address_district,
					zipcode: data.address_zipcode,
					city_id: data.address_city_id
				};
			if (old_data)
				return await api.call(api.update_carrier, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_carrier, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Transportador', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do transportador' },
		{ index: 3, field: 'type', label: 'Tipo', types: [types.opt_person_type()], placeholder: '', title: 'Tipo de personalidade jurídica' },
		{ index: 4, field: 'nick', label: 'Apelido', types: [types.datalist()], placeholder: '', title: 'Nome curto do transportador' },
		{ index: 5, field: 'name', label: 'Nome', types: [], placeholder: '', title: 'Nome ou razão social' },
		{ index: 6, field: 'cpf', label: 'CPF', types: [types.cpf()], placeholder: '000.000.000-00', title: 'Número do CPF' },
		{ index: 7, field: 'cnpj', label: 'CNPJ', types: [types.cnpj()], placeholder: '00.000.000/0000-00', title: 'Número do CNPJ' },
		{ index: 8, field: 'ie', label: 'IE', types: [types.ie()], placeholder: '000.000.000', title: 'Inscrição Estadual' },
		{ index: 9, field: 'ie_type', label: 'Tipo IE', types: [types.opt_ie_type(), types.datalist()], placeholder: '', title: 'Tipo de Inscrição Estadual' },
		{ index: 10, field: 'phone', label: 'Fone', types: [types.phone()], placeholder: '+00 (00) 0000-0000', title: 'Telefone' },
		{ index: 11, field: 'email', label: 'Email', types: [types.email()], placeholder: 'abc@xyz.com', title: 'Email' },
	];

	carriers_crud.run(
		'carriers',
		'Transportadores',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default carriers;

